var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extra-large":"","hide-footer":"","title":"Lista de cidadãos cadastrados últimos 7 dias"}},[_c('List')],1)}
var staticRenderFns = []

export { render, staticRenderFns }